<script lang="ts">
    import { widont } from 'journalize';
    import AtAGlanceRow from './AtAGlanceRow.svelte';

    // utils
    import {
      isMeasure,
      isRunoff,
      isWinner,
      measureLabel,
      nameParts,
      orderedChoices,
      partyClass,
      yesNo,
    } from '../utils/race-helpers.js';

    // types
    import type { Race, CrosswalkImage } from '../types';

    /** Plain race data object (not a store). */
    export let race: Race;
    export let crosswalk: Record<string, CrosswalkImage>;
    export let label: string;
    export let hyperlink = '';
    export let maxCandidates = 2;
    export let hyperlinkInTitle = false;
    export let cycle = '';
    /** Show * next to incumbents (set on AtAGlanceContainer) */
    export let showIncumbents = false;

  // same order as the other tables - before votes: alphabetical
  // when results come in: by vote count
  // but aag only appears when results are in anyways
  $: sortedCandidates = orderedChoices(race);

  function areResultsYesNo(race: Race) {
    // Returns true only if EVERY candidate is 'yes' or 'no'
    return race.attributes.choices.every((x) => yesNo(x) !== null);
  }

  </script>
    {#if hyperlinkInTitle}
    <p class="aag-race contest__caption"><a href={hyperlink}>{widont(label || race.attributes.title)} &raquo;</a></p>
    {:else}
      <p class="aag-race">{widont(label || race.attributes.title)}</p>
    {/if}

    {#if cycle == 'primary'}
      <p class="aag-leading" aria-hidden={isMeasure(race)}>
        {#if !isMeasure(race)}
          Leading candidates
        {:else}
          <br>
        {/if}
      </p>
    {/if}

  <table class="contest__candidates aag">
    <tbody>
        {#each sortedCandidates as c, idx (c.choiceId)}
          {#if idx < maxCandidates}
          <tr
          class="candidate contest__candidate-row contest__candidate-row-{partyClass(c)}"
          class:contest__candidate-row-winner={isWinner(c)}>
          <AtAGlanceRow
            candidateFirstName = {nameParts(c).first}
            candidateMiddleName = {nameParts(c).middle}
            candidateLastName = {nameParts(c).last}
            choiceTitle = {yesNo(c) ? measureLabel(c) : undefined}
            choiceId = {c.choiceId}
            isIncumbent = {showIncumbents ? (c.isIncumbent ?? false) : false}
            isWinner = {isWinner(c)}
            candidateParty = {partyClass(c)}
            candidateVotes = {c.votes}
            totalVotes = {race.attributes.totalVotes}
            lookup={crosswalk[c.choiceId] ? crosswalk[c.choiceId] : crosswalk['person']}
            raceID = {race.id}
            isRunoff = {isRunoff(c)}
            wideBar = {areResultsYesNo(race)}
          />
          </tr>
          {/if}
        {/each}
    </tbody>
    <tfoot>
      <tr>

        <td class="contest__precincts" colspan=4 aria-hidden={!(race.attributes.eevp != null && (race.attributes.eevp > 0 || race.attributes.totalVotes === 0))}>
          {#if race.attributes.eevp != null && (race.attributes.eevp > 0 || race.attributes.totalVotes === 0)}
            {race.attributes.eevp.toFixed(1)}% of expected vote in
          {:else}
            <br/>
          {/if}
        </td>
        <!-- <td class="link-to-section text-right" colspan="2"><a href="#" aria-label="Link to go to race">Go to race &raquo;</a></td> -->
      </tr>
    </tfoot>
  </table>
